
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"438","height":"572","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M280.812 156.392c18.432-36.686 151.741-182.91 151.741-182.91L437.819-37-614.386 177.128l95.426 510.774s35.127 85.115 72.323 76.348c16.77-3.953 46.514-48.182 64.101-55.058 23.177-9.064 38.285-59.193 54.439-74.763 14.699-14.168 26.281-35.107 41.552-48.241 42.492-36.544 88.762-59.429 119.715-67.391 42.076-10.824 102.204-47.176 138.458-68.606 36.254-21.429 9.055-42.35 32.853-70.695 23.798-28.344 99.039-57.621 131.293-80.6 32.254-22.98 126.607-105.818 145.038-142.504z","fill":"url(#paint0_linear_1634_16855)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_1634_16855","x1":"59.325","y1":"427.83","x2":"-75.153","y2":"93.324","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#0FA","stop-opacity":".79"}}),_c('stop',{attrs:{"offset":".325","stop-color":"#0FA","stop-opacity":".5"}}),_c('stop',{attrs:{"offset":".651","stop-color":"#0FA","stop-opacity":".25"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0FA","stop-opacity":"0"}})])])])
          )
        }
      }
    